<form action="">
    <div class="row">
        <div class="col-12">Name</div>
        <dx-text-box class="col-12 m-2" [(value)]="form.name"></dx-text-box>
    </div>
    <div class="row">
        <div class="col-12">Broker Licenses</div>
        <div class="col-12 m-2">
            <app-data-grid
                [dataSource]="form.brokerRates"
                [config]="licenseConfig">
            </app-data-grid>
        </div>
    </div>
    <div class="row">
        <div class="col-12">Client Licenses</div>
        <div class="col-12 m-2">
            <app-data-grid [dataSource]="form.clientRates" [config]="licenseConfig">
            </app-data-grid>
        </div>
    </div>
    <div class="row">
        <div class="col-12">Discount Code</div>
        <dx-text-box class="col-12 m-2" [(value)]="form.discountCode"></dx-text-box>
    </div>
    <div class="row">
        <div class="col-12">Surveys</div>
        <dx-tag-box [items]="surveyList" displayExpr="name" valueExpr="_id" class="col-12 m-2" [(value)]="form.surveys"></dx-tag-box>
    </div>
    <div class="row">
        <div class="col-6"></div>
        <div class="col-6">
            <dx-button class="w-100 h-100" type="success" (onClick)="onSaveHandler()">
                Save
            </dx-button>
        </div>
    </div>
</form>